<!-- Timeouts section-->
<div [formGroup]="timeoutsForm">
  <div class="row gy-1">
    <div class="col-12">
      <app-common-checkbox  [formControl]="modifyBrowserTimeouts">
        <span class="checkbox-label">{{ 'modify_browser_timeouts' | translate }}</span>
      </app-common-checkbox>
    </div>

    <div *ngIf="modifyBrowserTimeouts?.value" class="col-12">
      <div class="row padding-left-lg gy-2">
        <!-- SWA timeouts section-->
        <div class="col-12">
          <h2 class="h5">{{ 'label_timeouts' | translate }}</h2>
        </div>
        <div class="col-12">
          <div class="row padding-left-lg gy-3" formGroupName="swaTimeouts">
            <div class="col col-lg-3 col-xl-3">
              <app-common-input
                class="mt-4"
                type="number"
                [form]="timeoutsForm.get($browserTimeouts.swaTimeouts)"
                [context]="{
                  label: 'swa_success_timeout',
                  field: $browserSwaTimeouts.SWA_SUCCESS_FIELD,
                  required: true,
                  autocomplete: 'off',
                  validateOnSubmitOnly: true,
                  min: 0,
                  step: 1,
                  inputmode: 'numeric',
                  pattern: '[0-9]*',
                }"
                [formValidationRequest$]="formValidationRequest$"
              >
              </app-common-input>
            </div>
            <div class="col col-lg-3 col-xl-3">
              <app-common-input
                class="mt-4"
                type="number"
                [form]="timeoutsForm.get($browserTimeouts.swaTimeouts)"
                [context]="{
                  label: 'swa_submit_timeout',
                  field: $browserSwaTimeouts.SWA_SUBMIT_FIELD,
                  required: true,
                  autocomplete: 'off',
                  validateOnSubmitOnly: true,
                  min: 0,
                  step: 1,
                  inputmode: 'numeric',
                  pattern: '[0-9]*',
                }"
                [formValidationRequest$]="formValidationRequest$"
              >
              </app-common-input>
            </div>
            <div class="col col-lg-3 col-xl-3">
              <app-common-input
                class="mt-4"
                type="number"
                [form]="timeoutsForm.get($browserTimeouts.swaTimeouts)"
                [context]="{
                  label: 'swa_username_timeout',
                  field: $browserSwaTimeouts.SWA_USER_NAME_FIELD,
                  required: true,
                  autocomplete: 'off',
                  validateOnSubmitOnly: true,
                  min: 0,
                  step: 1,
                  inputmode: 'numeric',
                  pattern: '[0-9]*',
                }"
                [formValidationRequest$]="formValidationRequest$"
              >
              </app-common-input>
            </div>
            <div class="col col-lg-3 col-xl-3">
              <app-common-input
                class="mt-4"
                type="number"
                [form]="timeoutsForm.get($browserTimeouts.swaTimeouts)"
                [context]="{
                  label: 'swa_password_timeout',
                  field: $browserSwaTimeouts.SWA_PASSWORD_FIELD,
                  required: true,
                  autocomplete: 'off',
                  validateOnSubmitOnly: true,
                  min: 0,
                  step: 1,
                  inputmode: 'numeric',
                  pattern: '[0-9]*',
                }"
                [formValidationRequest$]="formValidationRequest$"
              >
              </app-common-input>
            </div>
            <div class="col col-lg-3 col-xl-3">
              <app-common-input
                class="mt-4"
                type="number"
                [form]="timeoutsForm.get($browserTimeouts.swaTimeouts)"
                [context]="{
                  label: 'popup_timeout',
                  field: $browserSwaTimeouts.POPUP_DISMISS,
                  required: true,
                  autocomplete: 'off',
                  validateOnSubmitOnly: true,
                  min: 0,
                  step: 1,
                }"
                [formValidationRequest$]="formValidationRequest$"
              ></app-common-input>
            </div>
            <div class="col col-lg-3 col-xl-3">
              <app-common-input
                class="mt-4"
                type="number"
                [form]="timeoutsForm.get($browserTimeouts.swaTimeouts)"
                [context]="{
                  label: 'page_stabilization_timeout',
                  field: $browserSwaTimeouts.PAGE_STABILIZATION,
                  required: true,
                  autocomplete: 'off',
                  validateOnSubmitOnly: true,
                  min: 0,
                  step: 1,
                  inputmode: 'numeric',
                  pattern: '[0-9]*',
                }"
                [formValidationRequest$]="formValidationRequest$"
              ></app-common-input>
            </div>
            <div class="col col-lg-3 col-xl-3">
              <app-common-input
                class="mt-4"
                type="number"
                [form]="timeoutsForm.get($browserTimeouts.swaTimeouts)"
                [context]="{
                  label: 'page_redirects_stabilization_timeout',
                  field: $browserSwaTimeouts.PAGE_REDIRECTS_STABILIZATION,
                  required: true,
                  autocomplete: 'off',
                  validateOnSubmitOnly: true,
                  min: 0,
                  step: 1,
                  inputmode: 'numeric',
                  pattern: '[0-9]*',
                }"
                [formValidationRequest$]="formValidationRequest$"
              ></app-common-input>
            </div>
          </div>
        </div>

        <!-- AUF timeouts section-->
        <div class="col-12 mt-3">
          <h2 class="h5">{{ 'label_auf_timeouts' | translate }}</h2>
        </div>
        <div class="col-12">
          <div class="row padding-left-lg gy-3" formGroupName="aufTimeouts">
            <div class="col col-lg-3 col-xl-3">
              <app-common-input
                class="mt-4"
                type="number"
                [form]="timeoutsForm.get($browserTimeouts.aufTimeouts)"
                [context]="{
                  label: 'auf_click_timeout',
                  field: $browserAufTimeouts.USER_FLOW_CLICK_TIMEOUT,
                  required: true,
                  autocomplete: 'off',
                  validateOnSubmitOnly: true,
                  min: 0,
                  step: 1,
                  inputmode: 'numeric',
                  pattern: '[0-9]*',
                }"
                [formValidationRequest$]="formValidationRequest$"
              >
              </app-common-input>
            </div>
            <div class="col col-lg-3 col-xl-3">
              <app-common-input
                class="mt-4"
                type="number"
                [form]="timeoutsForm.get($browserTimeouts.aufTimeouts)"
                [context]="{
                  label: 'auf_open_url_timeout',
                  field: $browserAufTimeouts.USER_FLOW_OPEN_URL_TIMEOUT,
                  required: true,
                  autocomplete: 'off',
                  validateOnSubmitOnly: true,
                  min: 0,
                  step: 1,
                  inputmode: 'numeric',
                  pattern: '[0-9]*',
                }"
                [formValidationRequest$]="formValidationRequest$"
              >
              </app-common-input>
            </div>
            <div class="col col-lg-3 col-xl-3">
              <app-common-input
                class="mt-4"
                type="number"
                [form]="timeoutsForm.get($browserTimeouts.aufTimeouts)"
                [context]="{
                  label: 'auf_wait_element_timeout',
                  field: $browserAufTimeouts.USER_FLOW_WAIT_ELEMENT_TIMEOUT,
                  required: true,
                  autocomplete: 'off',
                  validateOnSubmitOnly: true,
                  min: 0,
                  step: 1,
                  inputmode: 'numeric',
                  pattern: '[0-9]*',
                }"
                [formValidationRequest$]="formValidationRequest$"
              >
              </app-common-input>
            </div>
            <div class="col col-lg-3 col-xl-3">
              <app-common-input
                class="mt-4"
                type="number"
                [form]="timeoutsForm.get($browserTimeouts.aufTimeouts)"
                [context]="{
                  label: 'auf_navigation_timeout',
                  field: $browserAufTimeouts.USER_FLOW_NAVIGATION_TIMEOUT,
                  required: true,
                  autocomplete: 'off',
                  validateOnSubmitOnly: true,
                  min: 0,
                  step: 1,
                  inputmode: 'numeric',
                  pattern: '[0-9]*',
                }"
                [formValidationRequest$]="formValidationRequest$"
              >
              </app-common-input>
            </div>
            <div class="col col-lg-3 col-xl-3">
              <app-common-input
                class="mt-4"
                type="number"
                [form]="timeoutsForm.get($browserTimeouts.aufTimeouts)"
                [context]="{
                  label: 'auf_keystroke_interval',
                  field: $browserAufTimeouts.USER_FLOW_KEYSTROKE_INTERVAL,
                  required: true,
                  autocomplete: 'off',
                  validateOnSubmitOnly: true,
                  min: 0,
                  step: 1,
                  inputmode: 'numeric',
                  pattern: '[0-9]*',
                }"
                [formValidationRequest$]="formValidationRequest$"
              ></app-common-input>
            </div>
            <div class="col col-lg-3 col-xl-3">
              <app-common-input
                class="mt-4"
                type="number"
                [form]="timeoutsForm.get($browserTimeouts.aufTimeouts)"
                [context]="{
                  label: 'auf_click_delay',
                  field: $browserAufTimeouts.USER_FLOW_CLICK_DELAY,
                  required: true,
                  autocomplete: 'off',
                  validateOnSubmitOnly: true,
                  min: 0,
                  step: 1,
                  inputmode: 'numeric',
                  pattern: '[0-9]*',
                }"
                [formValidationRequest$]="formValidationRequest$"
              ></app-common-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
